import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const Loader = () => {
  return (
    <DotLottieReact
      src="https://lottie.host/6a831c4a-8108-4fa3-9d86-325169bfbcb5/RV6bsu90cW.lottie"
      loop
      autoplay
    />
  );
};

export default Loader;